import React, { useEffect, useState } from 'react'
import { Button, Modal } from 'react-bootstrap'
import { Formik, Form } from "formik";
import { deletePost } from './PostApi';

export default function DeletePost(props) {
    const [show, setShow] = useState(false);

    useEffect(() => {
        setShow(props.show)
    }, [props]);

    const closeModal = () => {
        setShow(false)
        props.closeFromChild()
    }

    const submitForm = async (data) => {
        let response = await deletePost(data.post)
        if (response && response.status === 200) closeModal()
    }

    return (

        <Modal
            show={show}
            size="md"
            centered
            onHide={closeModal}
            onExit={closeModal}
        >
            <Formik
                initialValues={{post: props.post}}
                onSubmit={async (data) => await submitForm(data)}
            >
                <Form>
                    <Modal.Header closeButton>
                        <Modal.Title>Supprimer la newsletter</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>Voulez-vous vraiment supprimer cette newsletter ?</Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={closeModal}>Annuler</Button>
                        <Button type='submit'>Confirmer</Button>
                    </Modal.Footer>
                </Form>
            </Formik>
        </Modal>

    )
}
